export default __webpack_public_path__ + "static/media/Quicksand-Medium.01b181bb.woff";